<template>
  <v-card class="rounded-card card-shadow">
    <v-card-title class="font-weight-bold pl-5">
      Vendas por dia da semana
    </v-card-title>
    <figure style="width: 100%;">
      <v-chart :options="chart"
               ref="vendasDiasChart"
               theme="primary"
               autoresize/>
    </figure>
  </v-card>
</template>

<script>
import moment from 'moment';
import { toEchartData } from '@/utils/chart-utils';
import chartMixin from '@/mixins/chart-mixin';
import IndicadoresMarketplaceService from './indicadores-marketplace';


export default {
  mixins: [chartMixin],
  props: {
    stateDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      vendasDiaSemana: null,
      chart: null,
    };
  },
  computed: {
    query() {
      return `dataCompra >= ${this.stateDate.initialDate} and dataCompra <= ${this.stateDate.finalDate}`;
    },
  },
  methods: {
    showLoading() {
      this.$refs.vendasDiasChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      this.$refs.vendasDiasChart.hideLoading();
    },
    buildChart(data) {
      return {
        width: '80%',
        tooltip: {
          trigger: 'axis',
          formatter: this.tooltipFormatterAxis,
        },

        dataset: {
          source: [
            ['Orders'],
            ...toEchartData(data, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
        },
        yAxis: {
          splitNumber: 8,
          axisLabel: {
            formatter: this.axisMoneyFormatter,
          },
        },
        grid: {
          top: '15px',
          left: '16%',
        },
        series: [
          {
            type: 'bar',
            barMaxWidth: 16,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
    buildDataPoints(data) {
      const dataPoints = [];

      moment.weekdaysShort().forEach((day, index) => {
        dataPoints.push({
          description: day,
          value: data[index] || 0,
        });
      });
      this.chart = this.buildChart(dataPoints);
    },
    getComprasPorDiaSemana() {
      this.showLoading();
      IndicadoresMarketplaceService.getComprasPorDiaSemana({
        query: this.query,
      })
        .then(({ data }) => {
          this.vendasDiaSemana = data;
          this.buildDataPoints(this.vendasDiaSemana);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  watch: {
    stateDate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getComprasPorDiaSemana();
    },
  },
  mounted() {
    this.getComprasPorDiaSemana();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
  /*max-width: 400px;*/
}
</style>
